<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="schoolName">
        <span slot="label"><a-tooltip>{{ $t('学校名称') }}<template
          slot="title">{{ $t('学校名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.schoolName" :maxLength="255" :placeholder="$t('请输入')+'学校名称'">
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['schoolName']"
            input-type="input"
            table-name="school_school"
            table-field="schoolName"
            :field-value="form.schoolName"/>
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="schoolShortName">
        <span slot="label"><a-tooltip>{{ $t('学校简称') }}<template slot="title">{{ $t('学校简称') }}</template></a-tooltip> </span>
        <a-input v-model="form.schoolShortName" :maxLength="255" :placeholder="$t('请输入')"  allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="schoolMobile">
        <span slot="label"><a-tooltip>{{ $t('学校联系电话') }}<template slot="title">{{ $t('学校联系电话') }}</template></a-tooltip> </span>
        <a-input v-model="form.schoolMobile" :maxLength="128" :placeholder="$t('请输入')"  allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="schoolCode">
        <span slot="label"><a-tooltip>{{ $t('学校口令') }}<template slot="title">{{ $t('学校口令') }}</template></a-tooltip> </span>
        <a-input v-model="form.schoolCode" :disabled="formType===2" :maxLength="128" :placeholder="$t('请输入')"  allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="schoolLogo">
        <span slot="label"><a-tooltip>{{ $t('学校logo') }}<template slot="title">{{ $t('学校logo') }}</template></a-tooltip> </span>
        <oss-upload-single :height="100" :width="100"  v-model="form.schoolLogo" prefix="goods" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="schoolAreax">
        <span slot="label"><a-tooltip>{{ $t('学校所在地') }}<template
          slot="title">{{ $t('学校所在地') }}</template></a-tooltip> </span>
        <a-cascader :options="areaList"
                    :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                    :placeholder="$t('请选择')+'商家所在地'"
                    style="width: 100%" v-model="areaSelected" allowClear @change="onAreaChange">
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item prop="schoolAddress" >
        <span slot="label" >
          <a-tooltip>
            详细地区<template slot="title">详细地区</template>
          </a-tooltip>
        </span>
        <div id="amap" style="height: 450px; width: 470px">
          <school-map ref="schoolMap" @updateLocationMap="updateLocationMap"   style="height: 100%;" />
        </div>
      </a-form-model-item>

      <a-form-model-item prop="schoolDescription">
        <span slot="label"><a-tooltip>{{ $t('学校简介') }}<template slot="title">{{ $t('学校简介') }}</template></a-tooltip> </span>
        <a-input v-model="form.schoolDescription" :placeholder="$t('请输入')" type="textarea" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="leaderId">
        <span slot="label"><a-tooltip>{{ $t('负责人') }}<template slot="title">{{ $t('负责人') }}</template></a-tooltip> </span>
        <a-select  show-search :filter-option="leaderFilter"  v-model="form.leaderId" :maxLength="32" :placeholder="$t('请选择')+$t('负责人')" allow-clear>
          <a-select-option v-for="item in leaderList" :key="item.id">{{ item.leaderName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label"><a-tooltip>{{ $t('备注') }}<template
          slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getSchool, addSchool, updateSchool} from '@/api/school/school'
import {listSchoolLeader} from '@/api/school/schoolLeader'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import SchoolMap from "@/views/common/map.vue";


export default {
  name: 'CreateForm',
  props: {
    areaList: {
      require: true,
      type: Array,
      default: []
    },
    leaderList: {
      require: true,
      type: Array,
      default: []
    }
  },
  components: {
    OssUploadSingle,
    CustomDictTag,
    LocaleFieldButton,
    SchoolMap,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      areaSelected: [],
      leaderList: [],
      loading: '',
      // 表单参数
      form: {
        id: null,
        schoolName: null,
        schoolCode: null,
        schoolShortName: null,
        schoolLogo: null,
        schoolMobile: null,
        schoolAreap: null,
        schoolAreac: null,
        schoolAreax: null,
        schoolAddress: null,
        schoolLongitude: null,
        schoolLatitude: null,
        schoolStatus: 1,
        schoolDescription: null,
        leaderId: null,
        deptId: null,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        schoolName: [{required: true, message: this.$t('学校名称') + this.$t('不能为空'), trigger: 'blur'}],
        schoolLogo: [{required: true, message: this.$t('学校logo') + this.$t('不能为空'), trigger: 'change'}],
        schoolAddress: [{required: true, message: this.$t('详细地区') + this.$t('不能为空'), trigger: 'blur'}],
        schoolAreax: [{required: true, message: this.$t('所在地') + this.$t('不能为空'), trigger: 'change'}],
        schoolStatus: [{required: true, message: this.$t('学校状态') + this.$t('不能为空'), trigger: 'blur'}],
        schoolCode: [{required: true, message: this.$t('学校口令') + this.$t('不能为空'), trigger: 'blur'}],
        schoolMobile: [{required: true, message: this.$t('学校联系方式') + this.$t('不能为空'), trigger: 'blur'}]

      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      this.$refs.schoolMap.initMarker(null, null, null, null);
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        schoolName: null,
        schoolCode: null,
        schoolShortName: null,
        schoolLogo: null,
        schoolMobile: null,
        schoolAreap: null,
        schoolAreac: null,
        schoolAreax: null,
        schoolAddress: null,
        schoolLongitude: null,
        schoolLatitude: null,
        schoolStatus: 1,
        schoolDescription: null,
        leaderId: null,
        deptId: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    initMap(){
      let longitude = this.form.schoolLongitude
      let latitude = this.form.schoolLatitude
      let areac = this.form.schoolAreax
      let detailedAddress = this.form.schoolAddress
      this.$refs.schoolMap.initMarker(longitude, latitude, areac, detailedAddress);
    },
    updateLocationMap(data) {
      console.log('地图选点',data)
      this.form.schoolLatitude = data.lat
      this.form.schoolLongitude = data.lon
      this.form.schoolAddress=data.orgAddr
    },
    onAreaChange(value, selectedOptions) {
      this.form.schoolAreax = value[2]
      this.form.schoolAreac = value[1]
      this.form.schoolAreap = value[0]
      console.log('onAreaChange',this.form.schoolAreax)
      //初始化地图
      this.$refs.schoolMap.initMarker(selectedOptions[2].longitude, selectedOptions[2].latitude, value[1], '');
    },

    handleLeaderChange(value) {
      this.form.leaderId = value
    },
    handleLeaderSearch(value) {
      if (value === undefined || value === '') {
        listSchoolLeader({}).then(response => {
          this.leaderList = response.data || []
        })
        return
      }
      listSchoolLeader({leaderName: value}).then(response => {
        this.leaderList = response.data || []
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSchool({"id": id}).then(response => {
        this.form = response.data
        this.areaSelected = [this.form.schoolAreap,this.form.schoolAreac,this.form.schoolAreax]
        this.open = true
        this.formTitle = this.$t('修改')
        this.$nextTick(()=>{
          this.initMap()
        })
        listSchoolLeader({"id":response.data.leaderId}).then(res => {
          this.leaderList = res.data
        })

      })
    },
    leaderFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateSchool(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addSchool(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
